<template>
  <div class="customer-home" id="rootDom">
    <Header :info_phone="info_phone" :userInfo="userInfo"/>
    <NavBar />
    <Banner />
    <main
      class="customer-main"
      :class="{ moveUp: isMoveUp, moveDown: !isMoveUp }"
    >
      <router-view />
    </main>
    <Footer @emitInfoPhone="getInfoPhone" />
  </div>
</template>

<script>
// import store from "../../../store/index.js";
import store from '@/store/index.js';
export default {
  data() {
    return {
      info_phone: "",
      animation: "",
      isMoveUp: this.$route.name === "videodetail",
      userInfo:null
    };
  },
  components: {
    Header: () => import("./components/header.vue"),
    NavBar: () => import("./components/navbar.vue"),
    Banner: () => import("./components/banner.vue"),
    Footer: () => import("./components/footer.vue"),
  },
  created() {
    // console.log("route", this.$route);
    this.getUserInfo();
  },
  methods: {
    getInfoPhone(info_phone) {
      this.info_phone = info_phone;
    },
    /**
     * 获取用户信息
     */
     getUserInfo() {
      // console.log('进来咯---------',localStorage.getItem("token"))
      if (!localStorage.getItem("token")) {
        return;
      }
      const success = (res) => {
        let data = res.data;
        // 缓存获取到的用户信息
        // console.log('-----------1111111111111')
        sessionStorage.setItem("user_info_str", JSON.stringify(data.userinfo));
        sessionStorage.setItem("manage_url", data.manage_url);
        sessionStorage.setItem("ItcJwtToken", data.userinfo.ItcJwtToken);
        localStorage.setItem("token", data.token);
        store.commit("SET_USERINFO", data.userinfo);
        localStorage.setItem("userType", data.userinfo.type);
        this.$g.user_id = data.userinfo.id;
        this.userInfo=data.userinfo
      };
      const fail = (err) => {
        localStorage.clear();
        sessionStorage.clear();
      };
      this.$ajax.get("api/login/login", {
        func: {
          success,
          fail,
        },
      });
    },
  },
  watch: {
    $route(nv) {
      if (nv.name === "videodetail") {
        this.isMoveUp = true;
        window.scrollTo({
          top: 0,
        });
      } else {
        this.isMoveUp = false;
        window.scrollTo({
          top: 0,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-main {
  background-color: #f5f7fb;
}
.moveUp {
  position: relative;
  transition: transform 0.8s ease;
  transform: translateY(-260px);
  z-index: 100;
  margin-bottom: -260px;
}
.moveDown {
  z-index: 100;
  position: relative;
  transition: transform 0.8s ease;
  transform: translateY(0px);
}
</style>
